export enum BannerChannel {
  Name = "__banner__",
  MaintenanceEvent = "__banner--maintenance__",
  StagingEvent = "__banner--staging__",
  DevelopmentEvent = "__banner--development__",
  LocalEvent = "__banner--local__",
  ProductionEvent = "__banner--production__",
}

export function dispatchDevelopmentEvent() {
  localStorage.setItem("environment-banner", "development")

  const bannerChannel = new BroadcastChannel(BannerChannel.Name)
  bannerChannel.postMessage(BannerChannel.DevelopmentEvent)
  bannerChannel.close()
}

export function dispatchLocalEvent() {
  localStorage.setItem("environment-banner", "local")

  const bannerChannel = new BroadcastChannel(BannerChannel.Name)
  bannerChannel.postMessage(BannerChannel.LocalEvent)
  bannerChannel.close()
}

export function dispatchStagingEvent() {
  localStorage.setItem("environment-banner", "staging")

  const bannerChannel = new BroadcastChannel(BannerChannel.Name)
  bannerChannel.postMessage(BannerChannel.StagingEvent)
  bannerChannel.close()
}

export function dispatchMaintenanceEvent() {
  localStorage.setItem("environment-banner", "maintenance")

  const bannerChannel = new BroadcastChannel(BannerChannel.Name)
  bannerChannel.postMessage(BannerChannel.MaintenanceEvent)
  bannerChannel.close()
}

export function dispatchProductionEvent() {
  localStorage.setItem("environment-banner", "production")

  const bannerChannel = new BroadcastChannel(BannerChannel.Name)
  bannerChannel.postMessage(BannerChannel.ProductionEvent)
  bannerChannel.close()
}
